import type { LatestResultIdentity } from "../types";

export interface WecomContactWayResponse {
  user_ref: string;
  qr_code: string;
  status: "created" | "cached";
}

export class WecomContactWayError extends Error {
  constructor(public code: string, public status: number) {
    super(code);
    this.name = "WecomContactWayError";
  }
}

export async function loadWecomContactWay(identity?: LatestResultIdentity): Promise<WecomContactWayResponse> {
  if (!identity?.userRef || !identity.writeToken) throw new WecomContactWayError("missing_identity", 401);
  const response = await fetch("/api/wecom/contact-way", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user_ref: identity.userRef, write_token: identity.writeToken }),
  });
  const body = await response.json().catch(() => ({})) as Record<string, unknown>;
  if (!response.ok) {
    throw new WecomContactWayError(typeof body.error === "string" ? body.error : "contact_way_failed", response.status);
  }
  const result = {
    user_ref: String(body.user_ref || ""),
    qr_code: String(body.qr_code || ""),
    status: body.status === "cached" ? "cached" as const : "created" as const,
  };
  if (result.user_ref !== identity.userRef || !/^https:\/\//.test(result.qr_code)) {
    throw new WecomContactWayError("invalid_contact_way_response", 502);
  }
  return result;
}
